import { SupportedCountry } from "./supported-country";

export default class MerchantLocation {
  countryIso2: SupportedCountry;

  currencyIso3: string;

  currencySymbol: string;

  displayName: string;

  private constructor(
    countryIso2: SupportedCountry,
    currencyIso3: string,
    currencySymbol: string,
    displayName: string
  ) {
    this.countryIso2 = countryIso2;
    this.currencyIso3 = currencyIso3;
    this.currencySymbol = currencySymbol;
    this.displayName = displayName;
  }

  public static locations = [
    MerchantLocation.US(),
    MerchantLocation.UK(),
    MerchantLocation.IE(),
    MerchantLocation.CA(),
    MerchantLocation.AU(),
    MerchantLocation.BH(),
    MerchantLocation.OM(),
    MerchantLocation.IQ(),
    MerchantLocation.AE(),
    MerchantLocation.QA(),
    MerchantLocation.SA(),
    MerchantLocation.KW(),
  ];

  private static US(): MerchantLocation {
    return new MerchantLocation(
      SupportedCountry.US,
      "usd",
      "$",
      "United States of America"
    );
  }

  private static UK(): MerchantLocation {
    return new MerchantLocation(
      SupportedCountry.GB,
      "gbp",
      "£",
      "United Kingdom"
    );
  }

  private static IE(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.IE, "eur", "€", "Ireland");
  }

  private static CA(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.CA, "cad", "$", "Canada");
  }

  private static AU(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.AU, "aud", "$", "Australia");
  }

  private static BH(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.BH, "bhd", "د.ب", "Bahrain");
  }

  private static OM(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.OM, "omr", "ر.ع", "Oman");
  }

  private static IQ(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.IQ, "iqd", "ع.د", "Iraq");
  }

  private static AE(): MerchantLocation {
    return new MerchantLocation(
      SupportedCountry.AE,
      "aed",
      "د.إ",
      "United Arab Emirates"
    );
  }

  private static QA(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.QA, "qar", "ر.ق", "Qatar");
  }

  private static SA(): MerchantLocation {
    return new MerchantLocation(
      SupportedCountry.SA,
      "sar",
      "ر.س",
      "Saudi Arabia"
    );
  }

  private static KW(): MerchantLocation {
    return new MerchantLocation(SupportedCountry.KW, "kwd", "د.ك", "Kuwait");
  }

  public static from(countryIso2: string): MerchantLocation | undefined {
    if (!countryIso2) {
      return undefined;
    }
    const normalizedIso2 = countryIso2.toUpperCase();
    return MerchantLocation.locations.find(
      (l) => l.countryIso2 === normalizedIso2
    );
  }
}
